import React from 'react'
import dateService from 'live/services/date'
import { FileMetadata } from '../../api'

const InfoTooltip: React.FC<FileMetadata> = file => {
    return (
        <div className={'info-icon'}>
            <i className="fas fa-info-circle"></i>
            <div className={'tooltip'}>
                <ul className={'fa-ul'}>
                    <li>
                        <span className={'description'}>Wellbore Event Type: </span>
                        <span className={'value'}>{file.wellboreEventType}</span>
                    </li>
                    <li>
                        <span className={'description'}>File Name: </span>
                        <span className={'value'}>{file.fileName}</span>
                    </li>
                    <li>
                        <span className={'description'}>Last Modified: </span>
                        <span className={'value'}>{dateService.formatDateTime(file.lastModified)}</span>
                    </li>
                    <li>
                        <span className={'description'}>File Type: </span>
                        <span className={'value'}>{file.fileType}</span>
                    </li>
                    <li>
                        <span className={'description'}>File Size: </span>
                        <span className={'value'}>{file.fileSize}</span>
                    </li>
                    <li>
                        <span className={'description'}>Line Count: </span>
                        <span className={'value'}>{file.lineCount}</span>
                    </li>
                    <li>
                        <span className={'description'}>Log Type: </span>
                        <span className={'value'}>{file.logType}</span>
                    </li>
                    <li>
                        <span className={'description'}>Index Column: </span>
                        <span className={'value'}>{file.indexColumn}</span>
                    </li>
                    <li>
                        <span className={'description'}>Index UOM: </span>
                        <span className={'value'}>{file.indexUOM}</span>
                    </li>
                    <li>
                        <span className={'description'}>Index Format: </span>
                        <span className={'value'}>{file.indexFormat}</span>
                    </li>
                    <li>
                        <span className={'description'}>Start: </span>
                        <span className={'value'}>{dateService.formatDateTime(file.start)}</span>
                    </li>
                    <li>
                        <span className={'description'}>End: </span>
                        <span className={'value'}>{dateService.formatDateTime(file.end)}</span>
                    </li>
                    <li>
                        <span className={'description'}>Timezone: </span>
                        <span className={'value'}>{file.timezone}</span>
                    </li>
                    <li>
                        <span className={'description'}>Disabled: </span>
                        <span className={'value'}>{file.disabled}</span>
                    </li>
                    <li>
                        <span className={'description'}>Units on Header: </span>
                        <span className={'value'}>{file.unitsOnHeader}</span>
                    </li>
                </ul>
            </div>
        </div>
    )
}

export default InfoTooltip
